import React, { useState } from 'react';
import { Input } from './ui/input';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from './ui/select';

export const GEN_METER_OPTIONS = [
  { value: 'Emlite ECA2A-NZ', label: 'Emlite ECA2A-NZ', hint: 'Default for most inverters' },
  { value: 'Eastron SDM230-Modbus', label: 'Eastron SDM230-Modbus (1-ph)', hint: 'Solis / SunSynk' },
  { value: 'Eastron SDM630-Modbus', label: 'Eastron SDM630-Modbus (3-ph)', hint: 'Solis / SunSynk three-phase' },
  { value: 'Eastron SDM120-Modbus', label: 'Eastron SDM120-Modbus', hint: 'Compact 1-ph' },
];

const AUTO = '__auto__';
const OTHER = '__other__';

/** Rule of thumb: Solis or SunSynk → Eastron, everything else → Emlite ECA2A-NZ. */
export const suggestGenMeter = (inverterManufacturer, threePhase = false) => {
  const m = String(inverterManufacturer || '').toLowerCase();
  if (m.includes('solis') || m.includes('sunsynk') || m.includes('sun synk')) {
    return threePhase ? 'Eastron SDM630-Modbus' : 'Eastron SDM230-Modbus';
  }
  return 'Emlite ECA2A-NZ';
};

/** Dropdown of common generation meters. Empty value = "Auto" (rule above). */
export const GenMeterSelect = ({ value, onChange, inverterManufacturer, threePhase = false, className = '', testId = 'gen-meter-select' }) => {
  const known = GEN_METER_OPTIONS.some((o) => o.value === value);
  const [other, setOther] = useState(Boolean(value) && !known);
  const suggested = suggestGenMeter(inverterManufacturer, threePhase);
  const selectValue = other ? OTHER : (value ? value : AUTO);

  const handle = (v) => {
    if (v === AUTO) { setOther(false); onChange(''); return; }
    if (v === OTHER) { setOther(true); onChange(known ? '' : value || ''); return; }
    setOther(false); onChange(v);
  };

  return (
    <div className="space-y-1.5">
      <Select value={selectValue} onValueChange={handle}>
        <SelectTrigger className={className} data-testid={testId}><SelectValue /></SelectTrigger>
        <SelectContent>
          <SelectItem value={AUTO} data-testid={`${testId}-auto`}>Auto — {suggested}{inverterManufacturer ? ` (${inverterManufacturer})` : ''}</SelectItem>
          {GEN_METER_OPTIONS.map((o) => (
            <SelectItem key={o.value} value={o.value} data-testid={`${testId}-${o.value.replace(/[^a-z0-9]+/gi, '-').toLowerCase()}`}>
              {o.label} <span className="text-slate-400">· {o.hint}</span>
            </SelectItem>
          ))}
          <SelectItem value={OTHER} data-testid={`${testId}-other`}>Other (type a model)…</SelectItem>
        </SelectContent>
      </Select>
      {other && (
        <Input value={value || ''} onChange={(e) => onChange(e.target.value)} placeholder="e.g. Elster A100C"
          className={className} data-testid={`${testId}-other-input`} />
      )}
    </div>
  );
};

export default GenMeterSelect;
